// apiConfig.js
export const API_BASE_URL = process.env.REACT_APP_API_URL || '//www.peakmet.com'; 
//'//peakmet.com'; '//www.peakmet.com'; //'http://localhost:5000'; 
